module.exports = __webpack_public_path__ + "img/prize-01-icon.2f7eb45b.png";